<template>
  <div class="chat-contentContainer" style="display: flex;flex-direction: column;" @contextmenu="handelRightClick">
    <div class="chat-content" :class="to_type == 'user' || MsgMap['GOODS'] == type ? 'active' : 'bg'">
      <!-- Text Message -->
      <template v-if="MsgMap['TEXT'] == type">
        <div class="chat-text" v-html="$options.filters.textToHtml(content)"></div>
      </template>

      <!-- Image Message -->
      <template v-else-if="MsgMap['IMAGE'] == type">
        <el-image style="width:180px;height:180px;" fit="cover" :src="content" :preview-src-list="images_list"></el-image>
      </template>

      <!-- Image Message -->
      <template v-else-if="MsgMap['VIDEO'] == type">
        <video style="width:300px;height:180px;" :src="content" controls></video>
      </template>

      <!-- Goods Message -->
      <template v-else-if="MsgMap['GOODS'] == type">
        <a :href="goods_id|link(link_type)" target="_blank" class="goods-link" >
          <div class="flex goods-message">
            <div class="goods-image m-r-10">
              <el-image style="width:80px;height:80px" v-if="imageURL" :src="imageURL" ></el-image>
            </div>
            <div class="">
              <div class="goods-name nr line-2">
                {{ content }}
              </div>
              <div class="goods-price m-t-10 xs">￥{{ price }}</div>
            </div>
          </div>
        </a>
      </template>

      <!-- Link Message -->
      <template v-else-if="MsgMap['LINK'] == type">
        <a :href="content | linkTo" target="_blank" class="goods-link" >
          <div class="flex goods-message">
            <div class="goods-image m-r-10">
              <el-image style="padding:10px;width:80px;height:80px" v-if="data.content.payload.extra.icon" :src="data.content.payload.extra.icon" ></el-image>
            </div>
            <div class="">
              <div class="goods-name nr line-2" style="padding-right:10px;" v-if="data.content.payload.extra.type==='bidding'">
               点击填写【{{ data.content.payload.extra.name }}】游戏挂售资料
              </div>
            </div>
          </div>
        </a>
      </template>

      <!--   Coupon Message  -->

      <template v-else-if="MsgMap['COUPON'] == type && coupon_data">
          <div class="flex coupon_message">
            <div  class="flex coupon_detail">
              <div class="coupon_fee" :class="coupon_data.is_used?'used':''">
                <div>
                  <div>
                    <h2 v-if="coupon_data.discount_type === 0"><em class="money_icon">¥</em>{{coupon_data.discount_value*1}}</h2>
                    <h2 v-if="coupon_data.discount_type === 1">{{coupon_data.discount_value*1}}折</h2>

                  </div>
                  <div class="over">
                    <div v-if="coupon_data.coupon_type === 1">单笔订单满{{coupon_data.min_order_amount}}元</div>
                    <div v-if="coupon_data.coupon_type === 0">无门槛</div>
                  </div>
                </div>
              </div>
              <div class="coupon_content">
                <h2>{{ coupon_data.coupon_name }}</h2>
                <h3><div>于{{coupon_data.end_time}}过期</div></h3>
                <div class="comment">系统赠送优惠券 (用户{{coupon_data.is_used==1?'已使用':'未使用'}})</div>
              </div>
            </div>
          </div>
      </template>


      <!-- Card Message -->
      <template v-else-if="MsgMap['CARD'] == type">
        <div class="chat-text" v-html="$options.filters.textToHtml(content)"></div>
        <div class=" images chat-text" v-if="data?.content?.payload?.images">
          <div class="img" :style="'height:200px;width:calc( 100%/'+data.content.payload.images.length+' );overflow: hidden;max-width:200px;border-radius:5px;'" v-for="item in data.content?.payload?.images">
            <el-image fit="cover" :src="item" :preview-src-list="images_list"></el-image>
          </div>
        </div>
        <div class="btns chat-text" v-if="data.confirm_members?.indexOf('kefu_'+$net.userInfo.user_id)<0">
          <div class="btn yes" v-if="data.content?.payload?.btns?.yes&&(data.content.payload.btns.yes.user_type==undefined||data.content.payload.btns.yes.user_type=='kefu')"  @click="yes_btn(data.content.payload.btns.yes.fn)">
              {{data.content?.payload?.btns?.yes.txt}}
          </div>
          <div class="btn review"  v-if="data.content?.payload?.btns?.review" @click="review(data.content.payload.btns.review.fn)">
            {{data.content?.payload?.btns?.review.txt}}
          </div>
          <div class="btn refuse" v-if="data.content?.payload?.btns?.refuse" @click="refuse(data.content.payload.btns.refuse.fn)">
            {{data.content?.payload?.btns?.refuse.txt}}
          </div>
          <div class="btn accept" v-if="data.content?.payload?.btns?.accept" @click="accept(data.content.payload.btns.accept.fn)">
            {{data.content?.payload?.btns?.accept.txt}}
          </div>
        </div>
      </template>
      <div class="right" v-if="visible">
        <div class="func">
          <el-tag size="mini" :data-clipboard-text="content" @click.stop="copy">复制</el-tag>
           <el-tag size="mini" type="danger" @click.stop="recalled">撤回</el-tag>
        </div>
      </div>
    </div>

    <template>
      <div class="no" v-if="(data?.content?.msg_type==='private'&&data.content?.read?.length>=2)">
        <div>已读</div>
        <div class="time">{{data?.content?.timestamp | TimeStamp}}</div>
      </div>
      <div class="no" v-else-if="data?.content?.msg_type==='private'">
        <div>未读</div>
        <div class="time">{{data?.content?.timestamp | TimeStamp}}</div>
      </div>

      <el-popover
          v-else
          placement="right"
          title="未读成员"
          width="200"
          trigger="click"
      >
        <div v-if="member?.length - data?.content?.read?.length > 0" class="noRead no" slot="reference" @click="unreadMembers">
          <div>{{member?.length - data?.content?.read?.length }}人未读</div>
          <div class="time">{{data?.content?.timestamp | TimeStamp}}</div>

        </div>
        <div slot="reference" v-else @click="unreadMembers" class="no">
          <div>全部已读</div>
          <div class="time">{{data?.content?.timestamp | TimeStamp}}</div>
        </div>
        <div v-for="item in member" class="unreadMembers">
          <div class="member_avatar">
            <el-avatar size="small" :src="'https://img.taohaozhijia.cn/'+item.avatar"></el-avatar>
          </div>
          <div class="member_nickname">
            {{ item.nickname }}
          </div>
          <div class="member_read">
            {{ item.read }}
          </div>
        </div>
      </el-popover>
    </template>
    <template>
      <el-dialog
          title="审核信息"
          :visible.sync="reviewInfoDialog"
          :append-to-body="true"
          width="45%" class="review_box"
          @close="onViewClose"
          :close-on-click-modal="false"
      >
        <el-form :inline="true">
          <el-form-item label="联系人电话">
            <el-input  v-model="reviewData.phone"></el-input>
          </el-form-item>
          <el-form-item label="联系人亲属电话">
            <el-input  v-model="reviewData.parent_phone"></el-input>
          </el-form-item>
        </el-form>
        <div>审核信息图片</div>
        <div class="view_images">
          <el-upload :action="uploadURL"
                     accept=".jpg, .jpeg, .png, .JPG, .JPEG"
                     :headers="{ token: $store.getters.token, version }"
                     list-type="picture-card"
                     ref="real_upload"
                     :file-list="reviewImages"
                     :auto-upload="true"
                     :on-success="addImage"
             >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="dialogImageUrl=file.url;dialogUploadImgVisible=true">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="delImage(file,fileList)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <template #footer>
          <el-button @click="reviewInfoDialog = false">取 消</el-button>
          <el-button type="primary" @click="save">保存信息</el-button>
        </template>
      </el-dialog>
      <el-dialog :visible.sync="dialogUploadImgVisible"  :append-to-body="true">
        <img width="100%" :src="dialogImageUrl" >
      </el-dialog>
    </template>
  </div>
</template>

<script>
import {E_Msg} from "@/utils/enum";
import config from "@/config";
import {confirmMessage,refuseInfo,reviewInfo,acceptInfo,inputAccount,saveReviewInfo} from "@/api/app"
import {getCouponDetail} from "../../api/app";
import {Message} from "element-ui";
export default {
  name: "ChatContent",
  props: {
    unread: {
      type: Array,
      default: undefined
    },
    images_list: {
      type: Array,
      default: () => []
    },
    link_type: {
      type: String
    },
    goods_id: {
      type: String,
      require: true
    },
    groupMembers: {
      type: Array,
      default: () => []
    },
    type: {
      type: [String, Number],
      require: true,
    },
    content: {
      type: [String, Number],
      require: true,
    },
    to_type: {
      type: String,
      default: ''
    },
    is_read: {
      type: [String, Number],
      default: "0"
    },
    price: {
      type: [String, Number],
    },
    imageURL: {
      type: String,
    },
    msg_id: {
      type: [Number, String],
      require: true
    },
    msg_sn: {
      type: [Number, String]
    },
    thread_id: {
      type: [Number,String],
      require: true
    },
    data:{
      type:Object
    },
    messageId:{
      type:String
    }
  },
  data() {
    return {
      MsgMap: Object.freeze({...E_Msg}),
      member: "",
      visible: false,
      reviewInfoDialog:false,
      dialogUploadImgVisible:false,
      dialogImageUrl:'',
      reviewData:{
        images:[],
      },
      reviewImages:[],
      group_id:null,
      coupon_data:{},
      uploadURL: config.baseURL + "/tenantapi/upload/image",
      version: config.version,
    };
  },
  methods: {
    async save(){
        this.reviewData.images = this.reviewImages.map(item=>{
          return item.url;
        });
        const data = this.reviewData;
        const res = await saveReviewInfo(data);
      if(res.success){
        this.$message(res.msg);
      }
    },
    addImage(res,file,fileList){
      console.log('上传成功',fileList);
      this.reviewImages = fileList.map(item=>{
        console.log(item)
        return {name: item.name, url: item?.response?item.response.data.uri:item.url};
      })
      console.log(this.reviewImages);
    },
    delImage(file,fileList){
      this.reviewImages = this.reviewImages.filter(item=>{
        return item.url !== file.url;
      })
    },
    yes_btn(fn){
      if(fn==='confirm_instructions'){
          this.confirm_msg('confirm',fn);
      }
      if(fn==='input_account'){
          this.input_count();
      }
    },
    accept(fn){
      if(fn==='accept_info_submit'){
        this.$confirm('确认通过?','通过审核',{
          confirmButtonText: '通过',
          cancelButtonText: '取消',
          type: 'info',
          callback:(action,msg)=>{
            if(action==='confirm'){
              this.acceptReview();
            }
          }
        });

      }
    },
    async acceptReview(){
       const res = await acceptInfo({group_id:this.group_id});
       if(res.success){
         this.$message(res.msg);
         await this.confirm_msg('','input_info');
       }
    },
    async input_count(){
        const res = await inputAccount({group_id:this.group_id});
        if(res.success){
          this.$message(res.msg);
          await this.confirm_msg('','input_account');
        }
    },
    refuse(fn){
      if(fn==='refuse_info_submit'){
        this.$confirm('确认驳回并填写原因','确认驳回',{
          confirmButtonText: '驳回',
          cancelButtonText: '取消',
          type: 'error',
          showInput:true,
          callback:(action,msg)=>{
            if(action==='confirm'){
              this.refuse_info_submit(msg.inputValue);
            }
          }
        });
      }
    },
    async refuse_info_submit(reason){
      const res = await refuseInfo({group_id:this.group_id,messageId:this.data.messageId,reason:reason});
      if(res.success){
        this.$message.success(res.msg);
      }
    },
    async confirm_msg(fn='',type=null){
      const res = await confirmMessage({
        confirm_fn:type,
        thread_id:this.thread_id,
        user_id:this.$net.userInfo.user_type+"_"+this.$net.userInfo.user_id,
        'fn':fn
      });
      if(res.success){
        this.$message.success(res.msg);
        this.data.confirm_members.push(this.$net.userInfo.user_type+"_"+this.$net.userInfo.user_id);
        this.$forceUpdate();
      }
    },
    copy() {
      let r = navigator.clipboard.writeText(this.content);
      if(r) Message.success("复制成功");
      this.$nextTick(() => {
        this.visible = false;
      })
    },
    review(fn){
      if(fn=='review_info_submit'){
        this.reviewInfo();
      }
    },
    onViewClose(){
      this.reviewImages = [];
    },
    async reviewInfo(){
      const res = await reviewInfo({group_id:this.group_id});
      if(res.success){
         this.reviewInfoDialog = true;
         this.reviewData = res.data;
         const imgs = res.data.images.map(item=>{
           return {
             name: item,
             url: item,
           };
         });
        this.reviewImages = imgs;
      }
      return;
    },
    async recalled() {
      let datas ={
        "from":this.data.from ?? this.data.content.from,
        "to":this.data.to ?? this.data.content.to,
        "msg_type":this.data.content.msg_type ?? this.data.msg_type,
        "messageId":this.data.messageId,
        "thread_id":this.thread_id,
      }
      this.$net.recall(datas);
      this.visible = false;
    },
    handelRightClick(e) {
      e.preventDefault();
      this.visible = true;
    },
    unreadMembers() {
      this.$http.post("/tenantapi/kefu.kefu/unreadMembers", {
        msg_id: this.msg_id,
        msg_sn: this.msg_sn,
        thread_id: this.thread_id
      }).then(datas => {
        this.member = datas;
        this.member.map(item=>{
          if(this.data.content.read.includes(item.user_id)) return item;
          if(item.read==='已读') this.data.content.read.push(item.user_id);
          return item;
        })
      });
    },
    memberRead(datas) {
      if(this.messageId < datas.messageId){
        this.data.content.read = [...new Set([...datas.read,...this.data.content.read])];
      }else if(this.messageId === datas.messageId){
        this.data.content.read = datas.read;
        this.unreadMembers();
      }
    }
  },
  filters: {
    textToHtml(content) {
      if (content) {
        return content.replace(/\[em-([a-z_]+)\]/g, `<span class="em em-$1"></span>`)
            .replace(/@(\S+)/g, '<span style="color: red">@$1</span>')
            .replace(/\n/g, '<br>')
            .replace(/\\n/g, '<br>')
            .replace(/<color=([^>]+)>(.*?)<\/color>/g, '<span style="color: $1">$2</span>')
        // ✅ 通用替换 <color=xxx>...</color> 为 <span style="color:xxx">...</span>
      } else {
        return ''
      }
    },
    linkTo(val){
      return config.appURL+'index.html/#'+val;
    },
    link(id, link_type) {
      if (link_type == 'order') {
        return config.appURL + "index.html/#/pages/order/finish/orderPayAllRight?orderId=" + id;
      }else if(link_type=='bargain'){
        return config.appURL + "index.html/#/pages/order/orderPay?id=" + id;
      }
      return config.appURL + 'index.html/#/pages/index/game/detail?id=' + id;
    },
    TimeStamp(val){
      if(!val){
        val = Date.now(); 
      }
      let date = new Date(Number(val));
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) ;
      return  h + m ;
    }
  },
  watch: {
    is_read(val) {
    }
  },
  computed: {
    goods() {
      return JSON.parse(this.content);
    }
  },
  async mounted() {
    console.log("本条消息ID",this.messageId);
    this.member = this.groupMembers.map(item=>{
      return item.user;
    });
    if(this.type === '9'){
      this.coupon_data = await getCouponDetail({coupon_id:this.data.content.payload.coupon_id});
    }
    if(this.data.content.msg_type === 'group') this.group_id = this.data.to?.replace('group_','') ?? this.data.content.to?.replace('group_','');
    if(this.data.confirm_members && typeof this.data.confirm_members==="string") this.data.confirm_members = JSON.parse(this.data.confirm_members);
    else this.data.confirm_members = [];
    document.addEventListener('click', () => {
      this.visible = false;
    })
    this.$net.on('read', this.memberRead);
  },
  beforeDestroy() {
    this.$event.$off("read_back", this.memberRead);
    this.$net.off('read', this.memberRead);
  }
};
</script>

<style lang="scss" scoped>
.chat-contentContainer {
  //background-color: #fff0de;
}

.func {
  display: flex;
  gap: 5px;
  border-top: 1px solid #eee;
  padding-top: 3px;
}

.no {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  display: flex;
  gap: 5px;
}

.noRead {
  font-size: 12px;
  color: #4073fa;
  cursor: pointer;
  margin-top: 5px;
}

.active {
  border: 1px solid $--border-color-base;
  background-color: #fff;
}

.bg {
  background-color: $--color-primary;
  border: 1px solid #e5e5e5;
}

.message--my{
  .no{
    flex-direction: row-reverse;
  }
}

.chat-content {
  border-radius: 8px;
  max-width: 32em;

  .goods-message {
    width: 300px;
    color:#000;
    .goods-image {
      min-width: 80px;
      min-height: 80px;
    }

    .goods-price {
      color: #ff2c3c;
    }
  }

  .chat-text {
    word-wrap: break-word;
    margin: 10px;
  }
}

.el-image{
  display: block;
  border-radius: 4px;
}

.goods-link {
  text-decoration: none;
  color: unset;
}

.unreadMembers {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  gap: 10px;

  .member_nickname {
    width: 100px;
  }

  .member_read {
    width: 30px;
  }
}
.btns{
  display: flex;
  gap: 10px;
  column-count: 2;
  .btn {
    min-width: 70px;
    height: 30px;
    text-align: center;
    border-radius: 5px;
    color: #fff;
    line-height: 30px;
    cursor: pointer;
  }
  .yes{
    background: #f60;
  }
  .no,.refuse{
    background: red;
  }
  .review{
    background: #3f6de6;
  }
  .accept{
    background: #00c24c;
  }
}
.review_box{
  height: 90vh;
}
.view_images{
  height: 100%;
  margin: 20px;
  padding: 10px;
  display: flex;
  gap:15px;
  flex-wrap: wrap;
  .img{
    overflow: hidden;
    width: 150px;
    height: 150px;
    position: relative;
    .delete_img{
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 30px;
      z-index: 99999;
      cursor: pointer;
      color: #00000099;
    }
  }
}
.images{
  display: flex;
  gap:5px;
}
.coupon_message{
  background: #fff;
  color:#000;
}
.coupon_detail{
  height: 100%;
}
.coupon_fee{
  min-width: 5.3125rem;
  background-image: linear-gradient(to right, #f63f5d, #FF7424);
  background-color: #FF7424;
  border-radius: 3px 0 0 3px;
  overflow: hidden;
  height: 100%;
  text-align: center;
  margin: 0 auto;
}
.coupon_fee.used{
  background-image: linear-gradient(to right, #8b8b8b, #FF7424);
  background: #8b8b8b;
  height: 100%;
}
.money_icon{
  font-size: 15px;
}

.coupon_message .coupon_fee h2{
  color: #fff;
  margin:10px;
  font-size: 28px;
}

.coupon_fee .over{
  color: #fff;
  text-align: center;
  margin: 5px;
}
.coupon_content{
  margin:0 10px;
  width: 100%;
  font-size: 10px;
}
.coupon_content h2{
  font-size: 16px;
  margin: 0px;
}
.comment{
  color: gray;
}

</style>
